import { Breadcrumb, Layout, Menu, Image, Row, Col, Button, Modal, Upload, message, Input, Tabs, Typography, Checkbox } from 'antd';
import React, { useEffect, useState, useRef } from 'react';
import axios from 'axios';
import { Navigate, Outlet, useNavigate, useLocation } from 'react-router-dom'
import { EditOutlined, ExclamationCircleFilled, PlusOutlined } from '@ant-design/icons';
import PreviewImgModal from './Media/PreviewImgModal';
const { confirm } = Modal;
const PicModal = (props) => {
    const [fileList, setFileList] = useState([]);
    const [modal_img, set_modal_img] = useState(false);
    const [img, setImg] = useState('');
    useEffect(() => {
        setFileList(props.fileList)
    }, [props.fileList])
    const showConfirm = (e) => {
        confirm({
            title: '確認要刪除此張圖片嗎？',
            icon: <ExclamationCircleFilled />,
            okText: '確定',
            okType: 'primary',
            cancelText: '取消',
            onOk() {
                remove(e);
            },
        });
    };
    const handlePreview = (e) => {
        setImg(e.url);
        set_modal_img(true);
    }
    const remove = (e) => {
        setFileList(prev => prev.filter(filter_item => filter_item.uid !== e.uid));
    }
    const handleUpload = (e) => {
        // console.log(e);
        e = e.file;
        // console.log(e.file);
        let form_data = new FormData();
        form_data.append('inputFile', e);
        axios
            .post(`/cramSchool/api/file`, form_data,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                })
            .then((response) => {
                let file_id = parseInt(response.data.file_id);
                const dataurl = URL.createObjectURL(e);
                setFileList(
                    prev => {
                        return ([
                            ...prev,
                            {
                                uid: file_id,
                                url: dataurl
                            }
                        ])
                    }
                );
            })
    }
    return (
        <>
            <PreviewImgModal
                modal_img={modal_img}
                set_modal_img={set_modal_img}
                img={img}
            ></PreviewImgModal>
            <Modal
                style={{ pointerEvents: 'auto' }}
                open={props.picOpen}
                bodyStyle={{ backgroundColor: '#faf6f5' }}
                width={450}
                footer={false}
                className="modalStyle2"
                wrapClassName={"modalStyle2"}
                modalRender={(e) => <>
                    <div style={{ backgroundColor: '#faf6f5', padding: '20px', borderTop: `solid #f09a45 5px `, position: 'relative', height: '80vh' }}>
                        <Row gutter={[10, 10]} justify='center' style={{ minHeight: '65vh', maxHeight: '65vh', overflowY: 'scroll' }}>
                            <Col span={24} >
                                <Row gutter={[8, 8]} align={'middle'}>
                                    <Col span={24}>
                                        <Row justify="space-between" style={{ position: 'relative' }} align={'bottom'}>
                                            <img width="35%" height="35%" src='/cram_school/edit.png'></img>
                                            <Col style={{ fontWeight: 'bold', fontSize: '20px', position: 'absolute', zIndex: 99, top: 53, left: 32 }}>修改圖片</Col>
                                        </Row>
                                    </Col>
                                    <Col span={24} >
                                        <Row gutter={[8, 8]} align={'middle'}>
                                            <Col span={6}>上傳圖片</Col>
                                            <Col span={18}>
                                                <Upload
                                                    accept="image/png,image/jpeg,.mp4,.mov"
                                                    customRequest={handleUpload}
                                                    listType="picture-card"
                                                    fileList={fileList}
                                                    onPreview={handlePreview}
                                                    onRemove={e => showConfirm(e)}
                                                    // onChange={handleUpload} 
                                                    beforeUpload={false}
                                                    multiple
                                                >
                                                    <div>
                                                        <PlusOutlined />
                                                        <div
                                                            style={{
                                                                marginTop: 8,
                                                            }}
                                                        >
                                                            上傳圖片
                                                        </div>
                                                    </div>
                                                </Upload>
                                            </Col>
                                            <Col span={6}></Col>
                                            <Col span={18}>＊請注意圖片大小，限制在2MB以內</Col>
                                        </Row>
                                    </Col>
                                </Row>
                            </Col>
                            <Col span={20} style={{ position: 'absolute', bottom: '3vh' }}>
                                <Row gutter={[10, 10]} justify={"center"}>
                                    <Col>
                                        <Button size='large' style={{ background: '#4a4a4a', color: '#ffffff' }} onClick={(e) => props.setPicOpen(false)} block>取消</Button>
                                    </Col>
                                    <Col >
                                        <Button
                                            onClick={e => props.handleSubmit(fileList.map(map_item => map_item.uid))}
                                            size='large' style={{ background: `#f09a45`, color: '#ffffff' }} block
                                        >修改</Button>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    </div >
                </>}
                centered
            />
        </>
    )
}
export default PicModal;